var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"dark-use-white",attrs:{"src":require("@/assets/images/logo/logo35px.svg")}})}
var staticRenderFns = []

export { render, staticRenderFns }